import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { IExtendedFilterValue } from "@app/interfaces/dtos/IExtendedFilterValue";
import { FilterType } from "@studyportals/omnisearch-interfaces";
import { RouteLocation } from "vue-router";
import { IExtendedWithPortalTypeFilterValue } from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";

export class KeywordFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.KEYWORD;
	public isMultiSelect = false;
	private static instance: KeywordFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [];

	public static getInstance(): KeywordFilterMapper {
		if (!KeywordFilterMapper.instance) {
			KeywordFilterMapper.instance = new KeywordFilterMapper();
		}
		return KeywordFilterMapper.instance;
	}

	private constructor() {
		super();
	}
	public canBeIndexed(): boolean {
		return false;
	}

	public override async getExtendedFilterValuesFromRoute(route: RouteLocation): Promise<IExtendedFilterValue[]> {
		const queryKeyword = route.query?.[this.filterType];

		if (typeof queryKeyword === 'string' && queryKeyword.length > 0) {
			const filerValue = this.createExtendedFilterValue(queryKeyword);
			return filerValue ? [filerValue] : [];
		}

		return [];
	}

	public override getExtendedFilterValueById(id: string): IExtendedFilterValue | undefined {
		return this.createExtendedFilterValue(id);
	}

	public override getAllExtendedFilterValues(): IExtendedFilterValue[] {
		throw new Error('Not supported for KeywordFilterMapper');
	}

	private createExtendedFilterValue(keyword: string): IExtendedFilterValue | undefined {
		const text = keyword.trim();

		if(text.length === 0) return undefined;

		return {
			name: `"${text}"`,
			id: text
		};
	}
}
